import { Box, Container, Divider, Link, Typography } from "@mui/material";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link as BrowserLink } from "react-router-dom";
import ForgotPasswordForm from "../../components/Authentication/ForgotPasswordForm";
import Logo from "../../components/Logo";
import MessageModal from "../../components/MessageModal";
import ArrowRight from "../../icons/ArrowRight";

const aboutText = [
  {
    id: 0,
    text: "A complete PPM solution available via the Cloud to unlimited users within your organization.",
  },
  {
    id: 1,
    text: "Identify the most valuable projects with out of the box intake, scoring and selection.",
  },
  {
    id: 2,
    text: "Proactively manage issues, resources and project milestones to make better business decisions.",
  },
  {
    id: 3,
    text: "Support your stakeholders and decision makers with portfolio-level KPIs and metrics via dashboards and graphs.",
  },
  {
    id: 4,
    text: "Ensure that your strategic initiatives have the transparency and governance necessary for your company to adapt and succeed.",
  },
];

const ForgotPassword = () => {
  const [messageModalState, setMessageModalState] = useState(false);
  const [messageModalErrorState, setMessageModalErrorState] = useState(false);

  const queryString = window.location.search;
  const parameters = new URLSearchParams(queryString);
  const emailFromLogin = parameters.get("e");

  const handleMessageModalClose = () => {
    setMessageModalState(false);
  };

  const handleErrorMessageModalClose = () => {
    setMessageModalErrorState(false);
  };
  return (
    <>
      <Helmet>
        <title>Forgot Password | Projectric</title>
      </Helmet>
      <Box>
        <MessageModal
          messageModalState={messageModalState}
          handleMessageModalClose={handleMessageModalClose}
          message="Please check your mail to reset password"
        />
      </Box>
      <Box>
        <MessageModal
          messageModalState={messageModalErrorState}
          handleMessageModalClose={handleErrorMessageModalClose}
          message="Something went wrong, please check your credentials"
        />
      </Box>
      <Box>
        <Container
          maxWidth="lg"
          sx={{
            pt: 6,
            pl: {
              lg: 15,
              md: 10,
              sm: 6,
              xs: 2,
            },
            ml: 0,
            mr: 0,
          }}
        >
          <Link component={BrowserLink} to="/">
            <Logo
              sx={{
                height: 33,
                width: 42,
              }}
            />
          </Link>
        </Container>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            lg: "repeat(2, 1fr)",
            xs: "repeat(1, 1fr)",
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: "background.default",
            pt: 8,
          }}
        >
          <Container
            maxWidth="lg"
            sx={{
              pl: {
                lg: 15,
                md: 10,
                sm: 6,
                xs: 2,
              },
            }}
          >
            <Typography
              color="textPrimary"
              sx={{ fontWeight: "bold", fontSize: "32px" }}
              variant="h5"
            >
              One stop solution for your
            </Typography>
            <Typography
              color="primary.orange"
              sx={{ fontWeight: "bold", mt: 0.5, fontSize: "32px", mb: 4 }}
              variant="h5"
            >
              Project Portfolio Management
            </Typography>
            {aboutText.map((content) => (
              <Box key={content.id} sx={{ display: "flex", mt: 2 }}>
                <Box sx={{ pr: 2, mt: 0.5 }}>
                  <ArrowRight fontSize="medium" />
                </Box>
                <Box>
                  <Typography
                    color="textPrimary"
                    variant="body1"
                    sx={{
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: "400",
                      lineHeight: "24px",
                    }}
                  >
                    {content.text}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Container>
        </Box>
        <Box
          sx={{
            pt: 8,
          }}
        >
          <Container
            maxWidth="lg"
            sx={{
              pr: {
                lg: 15,
              },
              pl: {
                lg: 5,
              },
            }}
          >
            <Box
              sx={{
                px: { lg: 6, md: 4, sm: 3, xs: 2 },
                py: { lg: 4, md: 4, sm: 3, xs: 2 },
                backgroundColor: "background.paper",
                boxShadow: "0px 3px 4px rgba(45, 62, 86, 0.1)",
              }}
            >
              <Typography
                color="textPrimary"
                variant="h6"
                sx={{
                  pb: 2,
                  fontSize: "24px",
                  fontWeight: "bold",
                  lineHeight: "36px",
                }}
              >
                Forgot Password
              </Typography>
              <Box>
                <ForgotPasswordForm
                  setMessageModalState={setMessageModalState}
                  setMessageModalErrorState={setMessageModalErrorState}
                  emailFromLogin={emailFromLogin || ""}
                />
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
      <Container
        maxWidth="lg"
        sx={{
          mt: 6,
          px: {
            lg: 15,
          },
          py: 3,
        }}
      >
        <Divider />
        <Typography
          sx={{
            fontWeight: "400",
            fontSize: "12px",
            lineHeight: "20px",
            textAlign: "justify",
            pt: 1,
          }}
        >
          Projectric is a leading Project Portfolio Management solution that
          organizes project and program data into relevant, actionable
          information for making business decisions. We are a trusted partner
          for organizations that need to perform meaningful analysis, forecast
          outcomes, collaborate in a centralized resource and adapt quickly to
          changing business needs.
        </Typography>
      </Container>
    </>
  );
};

export default ForgotPassword;
